<script lang="ts">
export default {
  name: 'CardTitle',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { cn } from '@/lib/utils';

interface Props {
  class?: string;
}

const props = defineProps<Props>();

const titleClass = computed(() => cn('tw:text-2xl tw:font-semibold tw:leading-none tw:tracking-tight', props.class));
</script>

<template>
  <h3 :class="titleClass">
    <slot />
  </h3>
</template>
